import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { isFeatureEnabled } from '../../config/featureFlags';
import { ReservationDetailPage } from '../../components/ReservationDetailPage';
import { BUS_CAPS } from '../../components/reservation/capabilities';
import BusFlowPage from './pages/BusFlowPage';
import BusReservationsPage from './pages/BusReservationsPage';

const busVisible = () => isFeatureEnabled('HasBusServices');

/** Clicking a PNR/ticket number in "Rezervasyon Listesi" navigates to
 *  `bus/reservations/:identifier` — the shared `ReservationDetailPage` (see
 *  ../../components/ReservationDetailPage.tsx), re-fetched fresh via `Entry/Find`. No
 *  İptal Et — the bus provider offers no post-sale cancellation (legacy had none either;
 *  see docs/backend-requirements.md GEREK YOK). Info + documents only. */
export const busModule: ModuleDefinition = {
  routes: [
    { path: 'bus', element: <BusFlowPage /> },
    { path: 'bus/reservations', element: <BusReservationsPage /> },
    { path: 'bus/reservations/:identifier', element: <ReservationDetailPage capabilities={BUS_CAPS} /> },
  ],
  menuItems: [
    {
      label: 'Arama',
      path: 'bus',
      icon: <DirectionsBusIcon />,
      group: 'Otobüs',
      groupIcon: <DirectionsBusIcon />,
      isVisible: busVisible,
    },
    {
      label: 'Rezervasyon Listesi',
      path: 'bus/reservations',
      icon: <ListAltOutlinedIcon />,
      group: 'Otobüs',
      isVisible: busVisible,
    },
  ],
};
